export enum EResource {
  Brands = 'brands',
  Categories = 'categories',
  Fees = 'fees',
  Orders = 'orders',
  Posts = 'posts',
  POSProducts = 'posProducts',
  Products = 'products',
  Promocodes = 'promo-codes',
  Roles = 'roles',
  Settlement = 'settlement',
  Users = 'users',
  Admins = 'admins',
  Variants = 'variants',
  MarketplaceVariants = 'marketplace-variants',
  SubCategories = 'sub-categories',
  MainCategories = 'main-categories',
  MerchantsOrders = 'merchants/orders',
  SuppliersOrders = 'suppliers/orders',
  SupplierMappings = 'supplier-mappings',
  Suppliers = 'suppliers',
  Settings = 'settings',
  AllowedPages = 'allowed-pages',
  RolesAndPermissions = 'roles-and-permissions',
  CommunityCampaigns = 'community-campaigns',
  Contents = 'contents',
  Catalogs = 'catalogs',
  Offers = 'offers',
  VoucherBatches = 'voucher-batches',
  VoucherStockUpload = 'voucher-stock-upload',
  BulkPromoCodes = 'bulk-promo-codes',
  PromoRules = 'promo-rules',
  VariantCosts = 'variant-costs',
  CustomerCareIdentityCorrection = 'customer-care/superqi-identity-correction',
  CustomerCareBulkMerge = 'customer-care/superqi-bulk-merge',
  CustomerCareMergeAll = 'customer-care/superqi-merge-all',
}
